import React, { useState, useRef, useEffect } from "react"
import Slider from "react-slick"

import style from "./vdp.module.scss"

export default function VDPMainImage(props) {
  const slider = useRef(null)

  const { ListOfPhotos } = props.vehicle
  const { unavailableImg } = props

  const handleImgError = (event) => {
    event.target.onerror = null;
    event.target.src = unavailableImg
  }

  useEffect(() => {
    (ListOfPhotos.length > 1 ) &&  slider.current.slickGoTo(props.slide)
  }, [props.slide])

  const settings = {
    arrows: false,
    infinite: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    beforeChange: (old, idx) => {
      props.gotoSlide(idx)
    }
  }

  return (
    <div>
      {(ListOfPhotos.length < 2)
        ?
        (ListOfPhotos.length === 0)
          ?
          <img className={style["main-image"]}
               alt=""
               src={unavailableImg}/>
          :
            <img className={style["main-image"]}
                 alt=""
                 src={ListOfPhotos[0].PhotoUrl}
                 onError={(e) => handleImgError(e)} />
        
      :
          <Slider {...settings} ref={slider}>
            {
              ListOfPhotos.map((slide, idx) => (
                  <img className={style["main-image"]}
                       alt=""
                       src={slide.PhotoUrl}
                       onError={(e) => handleImgError(e)} />
              ))
            }
          </Slider>
      }
    </div>
  )
}